import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    status: "All",
    colors: [],
};

// create slice
const filtersSlice = createSlice({
    name: "filters",
    initialState,
    reducers: {
        statusChanged: (state, action) => {
            state.status = action.payload;
        },
        colorChanged: (state, action) => {
            const { color, changeType } = action.payload;
           
            switch (changeType) {
                case "added":
                    state.colors = [...state.colors, color];
                    break;

                case "removed":
                    state.colors = state.colors.filter((existingColor) => existingColor !== color);
                    break;
            }
        },
    },
});

export default filtersSlice.reducer;
export const { statusChanged, colorChanged } = filtersSlice.actions;